import {
  educationCiscoImage,
  educationLpiImage,
  educationMssqlImage,
  educationOracleImage,
  educationPearsonImage,
  educationCiscoIllustrationImage,
  classroom1Image,
  classroom2Image,
  classroom3Image,
  classroom4Image,
  classroom5Image,
  classroom6Image,
  classroom7Image,
  classroom8Image
} from '../themes/image'

export const academyItems = [
  {
    id: '1',
    name: { ka: 'Cisco-ს ქსელური აკადემია', en: 'Cisco Networking Academy', },
    logo_url: educationCiscoImage,
    illustration_url: educationCiscoIllustrationImage,
    about_texts: [
      {
        ka: 'ყოველწლიურად, მსოფლიოში Cisco–ს ქსელური აკადემიების ასობით ათასი სტუდენტი ახდენს საკუთარი ცოდნის დონის გაღრმავებასა და ახალი უნარ–ჩვევების შეძენას კომპიუტერული ქსელების დაგეგმვის, ინსტალაციისა და მართვის სფეროში. ეს ერთის მხრივ ხელს უწყობს მათი კარიერული პერსპექტივების გაფართოებას და მეორეს მხრივ უზრუნველყოფს კომპიუტერული ქსელების პროფესიონალებზე გლობალური მოთხოვნის დაკმაყოფილებას. ამჟამად, Cisco–ს ქსელური აკადემიის პროგრამაში ჩართულია 10000 აკადემია მსოფლიოს 165 ქვეყანაში, რომლებიც ამზადებენ სტუდენტებს მსოფლიოში აღიარებული საერთაშორისო სერტიფიკატების მოპოვებისთვის და საინფორმაციო-საკომუნიკაციო ტექნოლოგიების თითქმის ყველა სფეროში დასაქმებისთვის. Cisco-ს ქსელური აკადემიის სასწავლო კურსები მომზადებულია ყველა იმ მოთხოვნის გათვალისწინებით, რომლებიც დღეს არსებობს კომპიუტერული ქსელების დარგში და შეესაბამება 21–ე საუკუნის საინფორმაციო ტექნოლოგიების განვითარების ტენდენციებს.',
        en: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
      },
    ],
  },
  {
    id: '2',
    name: { ka: 'LPI-ს აკადემია', en: '', },
    logo_url: educationLpiImage,
    illustration_url: '',
    about_texts: [
      {
        ka: '',
        en: '',
      },
    ],
  },
  {
    id: '3',
    name: { ka: 'MS SQL-ის მონაცემთა ბაზები', en: '', },
    logo_url: educationMssqlImage,
    illustration_url: '',
    about_texts: [
      {
        ka: '',
        en: '',
      },
    ],
  },
  {
    id: '4',
    name: { ka: 'Oracle-ის მონაცემთა ბაზები', en: '', },
    logo_url: educationOracleImage,
    illustration_url: '',
    about_texts: [
      {
        ka: '',
        en: '',
      },
    ],
  },
]

export const cerCentersItems = [
  {
    id: '',
    name: {
      ka: 'Pearson Vue-ს საგამოცდო ცენტრი',
      en: 'Pearson Vue Test Center',
    },
    logo_url: educationPearsonImage,
    website: 'https://www.pearsonvue.com/',
    description: {
      ka: 'Pearson VUE არის ლიდერი ორგანიზაცია ონლაინ ტესტირების სფეროში. იგი უზრუნველყოფს კომპიუტერის მეშვეობით ტესტირებების ჩატარებას საინფორმაციო ტექნოლოგიების თითქმის ყველა კომპანისთვის.აღნიშნული ტესტირებები ტარდება საგამოცდო პროცედურების უსაფრთხოების ყველა სტანდარტის დაცვით მსოფლიოს 175 ქვეყანაში.',
      en: 'Pearson Vue Test Center',
    },
  },
]

export const classroomPhotosItems = [
  {
    id: '',
    photo_url: classroom1Image,
  },
  {
    id: '',
    photo_url: classroom2Image,
  },
  {
    id: '',
    photo_url: classroom3Image,
  },
  {
    id: '',
    photo_url: classroom4Image,
  },
  {
    id: '',
    photo_url: classroom5Image,
  },
  {
    id: '',
    photo_url: classroom6Image,
  },
  {
    id: '',
    photo_url: classroom7Image,
  },
  {
    id: '',
    photo_url: classroom8Image,
  },
]

export const courseDurationUnitsItems = [
  {
    id: '1',
    title: { ka: 'თვე', en: 'month', },
  },
]

export const courseLanguagesItems = [
  {
    id: '1',
    title: { ka: 'ქართული', en: 'Georgian', },
  },
  {
    id: '2',
    title: { ka: 'ინგლისური', en: 'English', },
  },
]

export const courseRegistrationsItems = [
  {
    academy: '1',
    course: '1',
    start_date: '',
    end_date: '',
    is_opened: true,
    is_completed: false,
    form_id: '',
  },
  {
    academy: '2',
    course: '4',
    start_date: '',
    end_date: '',
    is_opened: true,
    is_completed: false,
    form_id: '',
  },
]

export const coursesItems = [
  {
    id: '1',
    academy: '1',
    name: { ka: 'CCNA', en: 'CCNA', },
    price: '1600',
    duration_range: ['6', '7'],
    duration_unit: '1',
    frequency: '3',
    language: '1',
    materials_language: '2',
    lesson_duration: ['2', '2.5'], 
    start_time: ['10:00', '19:00'],
    payment_description: [
      {
        ka: 'სწავლის საფასურის გადახდა უნდა მოხდეს სწავლის დაწყებიდან არაუგვიანეს 15 დღის განმავლობაში. სტუდენტს შეუძლია სწავლის საფასურის გადახდა როგორც მთლიანად, ასევე ნაწილ–ნაწილ. თუ სტუდენტს ურჩევნია სწავლის საფასურის გადახდა ეტაპობრივად, მან უნდა გადაიხადოს ყოველი სემესტრის დაწყებიდან 15 დღის განმავლობაში სასწავლო კურსის მთლიანი ღირებულების 1/3–ს. უმაღლესი სასწავლო დაწესებულებების სტუდენტებს და სკოლის მოსწავლეებს შეუძლიათ მიიღონ 20%–იანი ფასდაკლება, თუ ისინი სწავლის დაწყებისთანავე წარმოადგენენ შესაბამის დამადასტურებელ ცნობას საკუთარი სასწავლო დაწესებულებიდან.',
        en: '',
      },
      {
        ka: 'თუ სტუდენტი დროულად არ გადაიხდის სწავლის საფასურს, მას შეუწყდება Cisco–ს ქსელურ აკადემიაში სწავლის გაგრძელების უფლება.',
        en: '',
      },
    ],
    study_process_description: [
      {
        ka: 'სასწავლო კურსში გამოყენებულია Cisco–ს ქსელური აკადემიის მიერ შემუშავებული ოფიციალური სასწავლო მასალა, რომელიც წარმოდგენილია მხოლოდ ინგლისურ ენაზე. მისი განახლება ხდება პერიოდულად, რათა მასში ასახული იყოს თანამედროვე კომპიუტერული ქსელების განვითარების ტენდენციები.',
        en: '',
      },
      {
        ka: 'პრაქტიკული უნარ–ჩვევების გაღრმავებისთვის და საშინაო დავალებების შესრულებისთვის სტუდენტებს ეძლევათ Cisco–ს აკადემიის მიერ შექმნილი სპეციალური კომპიუტერული პროგრამის "Packet Tracer"–ის გამოყენების საშუალება, რომელიც უზრუნველყოფს კომპიუტერული ქსელების მოდელირებასა და სიმულაციას.',
        en: '',
      },
      {
        ka: 'სასწავლო კურსის ლექციების 40% შედგება პრაქტიკული ლაბორატორიული სამუშაოებისგან, რომელთა მსვლელობისას სტუდენტებს ეძლევათ Cisco–ს მოწყობილობებთან მუშაობის საუკეთესო შესაძლებლობა, რაც დაეხმარება მათ თეორიული საკითხების უკეთ აღქმასა და გააზრებაში.',
        en: '',
      },
    ],
    syllabus_url: 'https://www.grena.ge/',
    registration_instructions: [
      {
        ka: 'CCNA კურსზე მოსახვედრად სტუდენტმა უნდა გაიაროს ელექტრონული რეგისტრაცია. სარეგისტრაციო ფორმის შევსების და წარდგენის შემდეგ, მსურველი ავტომატურად ხდება Cisco–ს აკადემიის CCNA კურსის აბიტურიენტი, რის შესახებაც მას ეგზავნება ავტომატური დამადასტურებელი ელექტრონული წერილი სარეგისტრაციო ფორმაში მითითებულ ელ–ფოსტის მისამართზე.',
        en: '',
      },
      {
        ka: 'იმისათვის, რომ აბიტურიენტი ჩაირიცხოს CCNA სასწავლო კურსზე, მან უნდა ჩააბაროს ინგლისურ ენაში ტესტირება. აღნიშნული ტესტირება ტარდება ჩვენს აკადემიაში, აბიტურიენტების რეგისტრაციის დასრულების შემდეგ. ტესტირების ზუსტ თარიღს და დროს აბიტურიენტებს პირადად შეატყობინებენ ელექტრონული წერილის და ტელეფონის მეშვეობით.',
        en: '',
      },
      {
        ka: 'ინგლისური ტესტი უფასოა და მისი გავლა სავალდებულოა ყველა აბიტურიენტისთვის, ვისაც სურვილი აქვს ჩაირიცხოს სასწავლო კურსზე, რადგან ამ ტესტით ხდება მათი ინგლისური ენის ცოდნის დონის შემოწმება. იმის გამო, რომ სასწავლო მასალა და ყველა ის ტესტები, რომლებსაც სტუდენტები აბარებენ სწავლის პროცესში წარმოდგენილია მხოლოდ ინგლისურ ენაზე, ინგლისურის ცოდნა აუცილებელია საკმაოდ მაღალ დონეზე.',
        en: '',
      },
      {
        ka: 'ინგლისური ენის ტესტირებაზე აბიტურიენტებს მოეთხოვებათ დაახლოებით ერთგვერდიანი ტექსტის თარგმნა ინგლისურიდან ქართულ ენაზე. აღნიშნული ტექსტი, როგორც წესი ამოღებულია იმ სასწავლო მასალიდან, რომელსაც სტუდენტები შემდგომ გაივლიან.',
        en: '',
      },
      {
        ka: 'ხშირ შემთხვევაში, როდესაც CCNA სასწავლო კურსზე კონკურსი მაღალია, სტუდენტებს ასევე უწევთ IQ ტესტის ჩაბარება, რომელიც აფასებს მათი ლოგიკური აზროვნების უნარს.',
        en: '',
      },
      {
        ka: 'სტუდენტების ჩარიცხვა სასწავლო კურსზე ხდება ინგლისური ენის და IQ ტესტის შედეგების მიხედვით. სტუდენტები, რომლებიც მიიღებენ გამსვლელ ქულას, ჩაირიცხებიან შესაბამის ჯგუფებში (დილის და საღამოს ჯგუფებში). დილის და საღამოს ჯგუფების დაკომპლექტება ხდება რეგისტრაციისას ამორჩეული ლექციების ჩატარების სასურველი დროის მიხედვით. სასწავლო პროცესის დაწყების შემდეგ სტუდენტებს არ შეუძლიათ სხვა ჯგუფში გადასვლა.',
        en: '',
      },
      {
        ka: 'დამატებითი ინფორმაციისთვის დაგვიკავშირდით საკონტაქტო ტელეფონის ნომერზე ან ელ–ფოსტის მისამართზე.',
        en: '',
      },
    ],
  },
  {
    id: '2',
    academy: '1',
    name: { ka: 'CCNA Security', en: '', },
    price: '800',
    duration_range: ['2.5', '3'],
    duration_unit: '1',
    frequency: '3',
    language: '1',
    materials_language: '2',
    lesson_duration: ['2', '2.5'], 
    start_time: ['19:00'],
    payment_description: [
      {
        ka: '',
        en: '',
      },
    ],
    study_process_description: [
      {
        ka: '',
        en: '',
      },
    ],
    syllabus_url: '',
    registration_instructions: [
      {
        ka: '',
        en: '',
      },
    ],
  },
  {
    id: '3',
    academy: '1',
    name: { ka: 'VOIP', en: '', },
    price: '800',
    duration_range: ['3'],
    duration_unit: '1',
    frequency: '3',
    language: '1',
    materials_language: '2',
    lesson_duration: ['2', '2.5'], 
    start_time: ['17:00'],
    payment_description: [
      {
        ka: '',
        en: '',
      },
    ],
    study_process_description: [
      {
        ka: '',
        en: '',
      },
    ],
    syllabus_url: '',
    registration_instructions: [
      {
        ka: '',
        en: '',
      },
    ],
  },
  {
    id: '4',
    academy: '2',
    name: { ka: 'LPIC-1', en: '', },
    price: '1000',
    duration_range: ['3.5'],
    duration_unit: '1',
    frequency: '3',
    language: '1',
    materials_language: '2',
    lesson_duration: ['2'], 
    start_time: ['17:00'],
    payment_description: [
      {
        ka: '',
        en: '',
      },
    ],
    study_process_description: [
      {
        ka: '',
        en: '',
      },
    ],
    syllabus_url: '',
    registration_instructions: [
      {
        ka: '',
        en: '',
      },
    ],
  },
]